module.exports = "/fonts/element-icons.ttf?4520188144a17fb24a6af28a70dae0ce";